import { useCallback, useState } from 'react';
import type { SelectedFeeOption, SelectedFeeOptions } from '@/src/types/costAndFees.type';

export type CostAndFeesCalculatorState = {
  selectedBedCount: number | null;
  setSelectedBedCount: (bedCount: number | null) => void;
  selectedUnitZpid: string | null;
  setSelectedUnitZpid: (unitZpid: string | null) => void;
  selectedFeeOptions: SelectedFeeOptions;
  updateSelectedFeeOption: (feeKey: string, selection: SelectedFeeOption | null) => void;
};

export function useCostAndFeesCalculatorState(): CostAndFeesCalculatorState {
  const [selectedBedCount, setSelectedBedCount] = useState<number | null>(null);
  const [selectedUnitZpid, setSelectedUnitZpid] = useState<string | null>(null);
  const [selectedFeeOptions, setSelectedFeeOptions] = useState<SelectedFeeOptions>({});
  const updateSelectedFeeOption = useCallback((feeKey: string, selection: SelectedFeeOption | null) => {
    setSelectedFeeOptions((previous) => {
      const next = { ...previous };
      if (selection) next[feeKey] = selection;
      else delete next[feeKey];
      return next;
    });
  }, []);

  return {
    selectedBedCount,
    setSelectedBedCount,
    selectedUnitZpid,
    setSelectedUnitZpid,
    selectedFeeOptions,
    updateSelectedFeeOption,
  };
}
